var mimeType = 'audio/webm;codecs=opus'

class Call {
	recording = false
	incoming = {}
	outgoing = {}
	calls = {}
	player = {}
	muted = {}
	timer = false
	constructor() {
		ios.on('vcs', this.on_sync.bind(this))
		ios.on('vcd', this.on_data.bind(this))
		ios.on('vcvol', this.on_volume.bind(this))
		ios.on('vcpu', this.restart.bind(this))
		ios.on('vcpus', this.stop.bind(this))
		ios.on('vcrt', this.on_ringtone.bind(this))
		ios.on('vcrts', this.on_ringtone_stop.bind(this))

		this.ringtone = document.createElement('audio')
		this.ringtone.src = '/sound/ringtone.mp3'
		this.ringtone.loop = true
		this.ringtone.volume = 0.75
	}
	call(username) {
		emit({
			id: 'vcc',
			u: username,
		})
	}
	call_cancel(username) {
		emit({
			id: 'vccc',
			u: username,
		})
	}
	call_reject(username) {
		emit({
			id: 'vccr',
			u: username,
		})
	}
	pick_up(username) {
		emit({
			id: 'vcpu',
			u: username,
		})
	}
	mute(username) {
		emit({
			id: 'vcm',
			u: username,
		})
	}
	hang_up(username) {
		clearTimeout(this.hang_up_timeout)
		this.hang_up_timeout = setTimeout(function () {
			emit({
				id: 'vchu',
				u: username,
			})
		}, 333)
	}
	volume(username, e) {
		var o = storage.get()
		if (!o.vcvolume) {
			o.vcvolume = {}
		}
		o.vcvolume[username] = e.target.value
		storage.update(o)
		clearTimeout(this.volume_timeout)
		this.volume_timeout = setTimeout(function () {
			emit({
				id: 'vcvol',
				u: username,
				v: o.vcvolume[username],
			})
		}, 100)
	}
	on_volume(data) {
		if (CallListComponent.refs[data.u + '-volume']) {
			CallListComponent.refs[data.u + '-volume'].value = data.v
			if (this.player[data.u] && this.player[data.u].audio) {
				this.player[data.u].audio.volume = +data.v / 100
			}
		}
	}

	on_sync(data) {
		this.outgoing = data.outgoing || {}
		this.incoming = data.incoming || {}
		this.muted = data.muted || {}
		this.calls = data.calls || {}
		if (Object.keys(this.calls).length === 0) {
			clearInterval(this.timer)
			this.stop()
		} else {
			clearInterval(this.timer)
			this.timer = setInterval(
				function () {
					var now = Date.now()
					for (var username in this.player) {
						if (this.player[username].start) {
							var diff = (now - this.player[username].start) / 1000
							let seconds = Math.floor(diff % 60)
							seconds = seconds < 10 ? '0' + seconds : seconds + ''
							diff = Math.floor(diff / 60)
							let minutes = diff % 60
							minutes = minutes < 10 ? '0' + minutes : minutes + ''
							diff = Math.floor(diff / 60)
							let hours = diff % 24
							diff = Math.floor(diff / 24)
							let days = diff
							hours = hours + days * 24
							hours = hours < 10 ? '0' + hours : hours + ''

							if (hours === '00') {
								this.player[username].timer = '0' + ':' + minutes + ':' + seconds
							} else {
								this.player[username].timer = hours + ':' + minutes + ':' + seconds
							}
							document.querySelector(
								'.a' + encodeURIComponent(username).replace(/[^a-z0-9]/gi, '') + '-timer',
							).innerText = this.player[username].timer
						}
					}
				}.bind(this),
				1000,
			)
		}

		for (var username in this.player) {
			if (!this.calls[username]) {
				delete this.player[username]
			}
		}
		for (var username in this.calls) {
			if (!this.player[username]) {
				this.player[username] = {}
				this.player[username].u = username
				this.player[username].chunks = []
				this.player[username].start = Date.now()
				this.player[username].timer = '0:00:00'
				this.player[username].sourcebuffer = false
				this.player[username].mediasource = false
			}
		}

		if (!Object.keys(this.incoming).length && !Object.keys(this.outgoing).length) {
			this.on_ringtone_stop()
		}
		CallListComponent.forceUpdate()
	}
	on_ringtone() {
		if (this.ringtone && this.ringtone.play && (this.ringtone.paused || !this.ringtone.played)) {
			if (Object.keys(this.calls).length === 0) {
				this.ringtone.volume = 0.75
			} else {
				this.ringtone.volume = 0.25
			}

			this.ringtone.play().catch(function () {})
			if (this.ringtone && this.ringtone.currentTime) {
				this.ringtone.currentTime = 0
			}
		}
	}
	on_ringtone_stop() {
		this.ringtone && this.ringtone.pause && this.ringtone.pause()
	}
	async on_data(data) {
		var player
		if (!this.player[data.u]) {
			this.player[data.u] = {}
			player = this.player[data.u]
			player.u = data.u
			player.chunks = []
			player.start = Date.now()
			player.timer = '0:00:00'
			player.sourcebuffer = false
			player.mediasource = false
		} else if (data.d.f) {
			player = this.player[data.u]
			player.chunks = []
			player.sourcebuffer = false
			player.mediasource = false
		} else {
			player = this.player[data.u]
		}
		if (data.d.d) {
			player.chunks.push(data)
		}
		if (player.chunks.length && (player.chunks[0].d.f || !player.sourcebuffer)) {
			if (this.create_sourcebuffer(player)) {
				var chunk = player.chunks.shift()
				var d = await ios.decode(chunk.d.d)
				player.sourcebuffer.appendBuffer(await d.arrayBuffer())
				Promise.resolve().then(function () {
					player.audio.play().catch(function () {})
					var o = storage.get()
					if (o.vcvolume && o.vcvolume[chunk.u]) {
						player.audio.volume = +o.vcvolume[chunk.u] / 100
					}
				})
			}
		} else if (player.chunks.length && player.sourcebuffer) {
			if (player.sourcebuffer.updating !== true) {
				if (player.audio.seekable.length) {
					var time = player.audio.currentTime
					var end = player.audio.seekable.end(player.audio.seekable.length - 1)
					if (end - time > 0.5) {
						//console.log('seeking', end - time, end - 0.3 - time)
						player.audio.currentTime = end - 0.3
					}
				}
				var chunk = player.chunks.shift()
				var d = await ios.decode(chunk.d.d)
				player.sourcebuffer.appendBuffer(await d.arrayBuffer())
				player.audio.muted = chunk.m ? true : false
			}
		}
	}
	create_sourcebuffer(player) {
		if (player.mediasource && player.mediasource.readyState === 'open') {
			if (player.sourcebuffer) {
				try {
					if (player.mediasource.sourceBuffers && player.mediasource.sourceBuffers.length) {
						while (player.mediasource.sourceBuffers.length)
							player.mediasource.removeSourceBuffer(player.mediasource.sourceBuffers[0])
					}
				} catch (e) {}
			}
			try {
				player.sourcebuffer = player.mediasource.addSourceBuffer(mimeType)
				player.sourcebuffer.onupdateend = this.on_data.bind(this, { u: player.u, d: {} })
				player.sourcebuffer.mode = 'segments'
			} catch (e) {
				player.sourcebuffer = false
				player.mediasource = new MediaSource()
				player.url = URL.createObjectURL(player.mediasource)
				player.audio = document.createElement('audio')
				player.audio.src = player.url

				return false
			}
			return true
		} else {
			player.sourcebuffer = false
			player.mediasource = new MediaSource()
			player.url = URL.createObjectURL(player.mediasource)
			player.audio = document.createElement('audio')
			player.audio.src = player.url
		}
	}

	record() {
		if (!this.recording) {
			this.recording = true

			navigator.mediaDevices
				.getUserMedia({
					video: false,
					audio: {
						echoCancellation: false,
						noiseSuppression: true,
						autoGainControl: true,
					},
				})
				.then(
					function (channel) {
						this.channel = channel
						this.channel.on_record_stop = this.on_stop.bind(this)
						this.stream()
					}.bind(this),
				)
				.catch(
					function (e) {
						console.log('permission error ', e)
						this.stop()
						this.recording = false
					}.bind(this),
				)
			return false
		}
		return true
	}
	stream() {
		try {
			this.recorder = new MediaRecorder(this.channel, { mimeType: mimeType })
			this.recorder.can_send = null
			this.recorder.data = []
			this.recorder.ondataavailable = function (e) {
				if (typeof e.data === 'undefined' || e.data.size === 0) return
				if (this.recorder.state != 'inactive') {
					this.recorder.data.push(e.data)
					if (!this.recorder.can_send && this.recorder.data.length > 1) {
						this.recorder.can_send = true
						emit({
							id: 'vcd',
							d: this.recorder.data.shift(),
							f: 1,
						})
					}
					if (this.recorder.can_send) {
						var data
						while ((data = this.recorder.data.shift())) {
							emit({
								id: 'vcd',
								d: data,
							})
						}
					}
				}
			}.bind(this)
			this.recorder.start(333)
		} catch (e) {
			console.log('media recorder error', e)
			this.stop()
		}
	}
	restart() {
		if (this.record()) {
			if (this.recorder && this.recorder.state != 'inactive') {
				this.recorder.onstop = this.stream.bind(this)
				this.recorder.stop()
			}
		}
	}
	on_stop() {
		this.recording = false
	}
	stop() {
		this.stop_stream(this.recorder)
		if (this.recorder && this.recorder.stream) {
			this.stop_stream(this.recorder.stream)
		}
		this.stop_stream(this.channel)

		if (this.recorder) this.stop_tracks(this.recorder)
		if (this.recorder) this.stop_tracks(this.recorder.stream)
		if (this.channel) this.stop_tracks(this.channel)
		if (this.channel) this.channel.on_record_stop()
	}
	stop_stream(stream) {
		if (stream) {
			if (stream.state && stream.state != 'inactive') {
				stream.stop()
			} else if (!stream.state && stream.stop) {
				stream.stop()
			}
		}
	}
	stop_tracks(stream) {
		if (stream) {
			if (stream.getAudioTracks) {
				stream.getAudioTracks().forEach(function (track) {
					track.stop()
				})
			}
			if (stream.getTracks) {
				stream.getTracks().forEach(function (track) {
					track.stop()
				})
			}
		}
	}
}

Promise.resolve().then(function () {
	Call = new Call()
})

var CallIcon = function () {
	return (
		<svg
			className="voice-call-svg pm"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 384 512"
		>
			<path
				fill="currentColor"
				d="M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
			></path>
		</svg>
	)
}
var CallList = React.createClass({
	mixins: [React.addons.PureRenderMixin],

	getInitialState: function () {
		window.CallListComponent = this
		return {}
	},

	render: function () {
		var o = storage.get()
		return (
			<Box col relative center className="calls">
				{Object.keys(Call.outgoing).map(function (username, idx) {
					return (
						<Box row width key={idx} center className="call-row call-pulse">
							<Box row grow left center>
								<a href={'#u/' + encodeURIComponent(username)}>
									<img src={Call.outgoing[username]} />
								</a>{' '}
								Calling {username}
							</Box>
							<Box
								center
								className="call-button  "
								hand
								title="Cancel Call"
								onClick={Call.call_cancel.bind(Call, username)}
							>
								<CallIcon />
							</Box>
						</Box>
					)
				})}
				{Object.keys(Call.incoming).map(function (username, idx) {
					return (
						<Box row width key={idx} center className="call-row call-pulse">
							<Box
								row
								grow
								left
								hand
								title="Pick Up"
								center
								onClick={Call.pick_up.bind(Call, username)}
							>
								<a href={'#u/' + encodeURIComponent(username)}>
									<img src={Call.incoming[username]} />
								</a>{' '}
								{username} Is Calling
							</Box>
							<Box
								hand
								title="Reject Call"
								center
								className="call-button  "
								onClick={Call.call_reject.bind(Call, username)}
							>
								<CallIcon />
							</Box>
						</Box>
					)
				})}
				{Object.keys(Call.calls).map(function (username, idx) {
					var v = o.vcvolume && o.vcvolume[username] ? o.vcvolume[username] : 75

					return (
						<Box row width key={idx} center className="call-row">
							<Box row grow left center title={'On Call With ' + username}>
								<a href={'#u/' + encodeURIComponent(username)}>
									<img src={Call.calls[username]} />
								</a>
								<span
									className={
										'timer a' + encodeURIComponent(username).replace(/[^a-z0-9]/gi, '') + '-timer'
									}
								>
									{Call.player[username] && Call.player[username].timer
										? Call.player[username].timer
										: '0:00:00'}
								</span>
								<input
									type="range"
									min="0"
									max="100"
									step="1"
									defaultValue={v}
									ref={username + '-volume'}
									onChange={Call.volume.bind(Call, username)}
								/>
							</Box>
							<Box
								hand
								title={Call.muted[username] ? 'Unmute' : 'Mute'}
								center
								onClick={Call.mute.bind(Call, username)}
								className={'call-button-mute ' + (Call.muted[username] ? ' muted' : '')}
							>
								<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
									<path
										fill="currentColor"
										d="M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
									></path>
								</svg>
							</Box>
							<Box
								hand
								title="Hang Up"
								center
								className="call-button"
								onClick={Call.hang_up.bind(Call, username)}
							>
								<CallIcon />
							</Box>
						</Box>
					)
				})}
			</Box>
		)
	},
})
